/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {BuilderQuestionnaire} from "../../../classes/questionnaire-builder/builder-questionnaire";
import {QuestionnaireModel} from "../../models/questionnaire-model";


export interface QuestionnairesJsonPutParams {
    body?: BuilderQuestionnaire
}

export function questionnairesJsonPut(http: HttpClient, rootUrl: string, params: QuestionnairesJsonPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel>> {
    const rb = new RequestBuilder(rootUrl, questionnairesJsonPut.PATH, 'put');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'application/json');

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireModel>;
        })
    );
}

questionnairesJsonPut.PATH = '/api/v1/questionnaires/json';
